"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.space=void 0;var space=["0",// 0 - VALID
"0.25rem",// 1 - VALID
"0.375rem",// 2
"0.5rem",// 3 - VALID
"0.625rem",// 4
"0.75rem",// 5 - VALID
"0.875rem",// 6
"1rem",// 7 - VALID
"1.125rem",// 8
"1.25rem",// 9
"1.375rem",// 10
"1.5rem",// 11 - VALID
"1.75rem",// 12
"2rem",// 13 - VALID
"2.25rem",// 14
"2.5rem",// 15
"2.75rem",// 16
"3rem",// 17 - VALID
"3.25rem",// 18
"3.5rem",// 19
"3.75rem",// 20
"4rem",// 21 - VALID
"4.25rem",// 22
"4.5rem",// 23
"4.75rem",// 24
"5rem",// 25
"5.25rem",// 26
"5.5rem",// 27
"5.75rem",// 28
"6rem",// 29
"auto",// 30
"-0.125rem",// 31
"-0.25rem",// 32
"-0.375rem",// 33
"-0.5rem",// 34
"-0.75rem",// 35
"-1rem",// 36
"6.25rem"// 37
];// Human-readable spaces
// 0.25rem
// 0.5rem
// 0.75rem
// 1rem
// 1.5rem
// 2rem
// 3rem
exports.space=space,space.xxs=space[1],space.xs=space[3],space.sm=space[5],space.md=space[7],space.lg=space[11],space.xl=space[13],space.xxl=space[17],space.xxxl=space[21];